import React from "react";
import {
  Image,
  ImageBox,
  HeroBlurb,
  Heading,
  PageContentWrapWithSideBar,
  Page,
  Section,
  Box,
  Text
} from "../theme";
import Pic from "../assets/court.jpg";
import Pic2 from "../assets/IMG_0100.JPG";
import Pic3 from "../assets/IMG_0101.JPG";
import Pic4 from "../assets/IMG_0102.JPG";
import Pic5 from "../assets/IMG_0103.JPG";

const About = props => (
  <Page>
    <ImageBox useFilter bg="primaryDark" width={1} bgImage={Pic}>
      <HeroBlurb heading="Our Story" image={Pic} color="secondaryLight" />
    </ImageBox>
    <PageContentWrapWithSideBar>
      <Section bg="secondaryLight" minHeight="0px" alignContent="center">
        <Heading maxWidth={900} fontSize={3} pt={5}>
          Like any long-standing institution, the Knoxville law firm of Egerton,
          McAfee, Armistead & Davis has a robust heritage...
        </Heading>
        <Text maxWidth={900}>
          Our attorneys have been doing business on Gay Street since 1932. For
          the first 70 years, the firm’s offices were located at the
          intersection of Gay and Union streets. And it was there that founders
          M.W. Egerton, Sr. and Joseph A. McAfee began to practice law together
          in the grim days of the Depression. In 1932 the two young lawyers were
          selected to reorganize the East Tennessee National Bank—an institution
          that, like innumerable U.S. banks, had failed during that desperate
          year. They rented an office in the bank’s building and went to work.
          For the first two years, Egerton, one of the first Tennessee lawyers
          to practice federal tax law, was on the road to and from Washington,
          D.C. nearly constantly as the pair worked to get the bank’s charter
          reinstated. McAfee remained at the helm in Knoxville.
        </Text>

        <Text maxWidth={900}>
          Before long, their labor bore fruit. From the wreckage of East
          Tennessee National Bank they produced Park National Bank, then the
          largest bank in the city. For the creditors of the old bank, they
          managed to save 70 cents on the dollar, a phenomenally high recovery
          rate in that era. Park National Bank later became First American
          National Bank of Knoxville, a member of the state’s largest
          bank-holding company. John M. Armistead joined the law firm in 1940,
          and continued as a partner until his retirement in 2001. William W.
          Davis, Sr. joined in 1947 upon his graduation from the University of
          Tennessee College of Law, and he serves the firm to this day. When
          Davis became a partner, the firm’s current name was
          established—Egerton, McAfee, Armistead & Davis. Mont W. Egerton, Jr.
          joined the firm in the early 50s, and Joe Mont McAfee followed in
          1963.{" "}
        </Text>
      </Section>
    </PageContentWrapWithSideBar>
  </Page>
);
export default About;
